import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {AuthenticateService} from '../../../services/authenticate.service';
import {User} from '../../../models/user';
import {NavigationEnd, Router} from '@angular/router';
import { HttpClient } from '../../../services/http.service';
import { environment } from '../../../../environments/environment';
import {Subscription} from 'rxjs';
import {LockerService} from '../../../services/locker.service';
import {filter} from 'rxjs/operators';
import {CoreService} from '../core.service';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {

  public user: User;
  public check_production: boolean;
  public mouseOvered: boolean;

  private subscription: Subscription = new Subscription();

  constructor(public auth: AuthenticateService, private router: Router,
              private http: HttpClient, private s: CoreService) {
    /*
     * Получение данных текущего пользователя - добавлена подписка
     */
    this.subscription.add(this.auth.emit_user
      .subscribe((user) => this.user = user));
  }

  ngOnInit() {
    this.check_production = environment.test_version;
    this.subscription.add(this.router.events.pipe(filter(x => x instanceof NavigationEnd))
      .subscribe((x: NavigationEnd) => {
        this.s.navEndHappen();
      }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  logout() {
    this.serverLogout();
    this.router.navigateByUrl('/authenticate');
    this.auth.logout();
  }
  serverLogout() {
    this.http.post('Session.signout')
      .subscribe(
        (response) => true,
        (error) => false
      );
  }

  toggleSidebarMode() {
    this.s.sidebarToggle();
  }

  onLock() {
    this.serverLogout();
    LockerService.lock();
  }
  public isAccess(item: string) {
    return this.user.access[item];
  }

  onClickOutOfMenu(e: any) {
    this.s.onClickOutOfMenu(e);
  }

}
